export const translations = {
  en: {
    
    "social": {
      "tagline": "Follow the Flight",
      "title": "Our Social Media",
      "description": "Live flights, behind-the-scenes moments, and the best views of Rivas and Dominical — follow along closely on any of our channels.",
      "camera":"Gallery",
      "h2":"Air momets",
      "paragraph":" A selection of photos from our flights — the view of Rivas,Dominical, and the Pacific coast from above."
    },
    book:{
      deposit:"Deposit secures your slot",
      balance:"Pay the rest on landing"
    },
    nav: {
      destinations: "Destinations",
      tours: "Tandem",
      gallery: "Gallery",
      faq: "FAQ",
      book: "Book Now",
      costarica: "Costa Rica",
      brasil: "Brazil",
      peru: "Peru",
      argentina: "Argentina",
      canada: "Canada",
      rd: "Dominican Republic",
      rivas_perezzeledon: "Rivas de Pérez Zeledón, Costa Rica",
      dominicalito_dominical: "Dominicalito & Dominical, Costa Rica",
      uvita_whaletail: "Uvita · Whale Tail, Costa Rica",
      oasis_huacachina_peru: "Oasis Huacachina, Peru",
      florianopolis_brasil: "Florianópolis, Brazil",
      bariloche_argentina: "Bariloche, Argentina",
      ilha_do_mel: "Ilha do Mel, Brazil",
      caraguatatuba: "Caraguatatuba, Brazil",

    },
    hero: {
      image: "https://ik.imagekit.io/paraglidetour/the_best_paragliding_tour/paragliding_costa_rica_puravida.webp",
      overline: "Costa Rica's highest tandem paragliding flight · Pura Vida ",
      title: "The Best Paraglide Tour in Costa Rica.",
      subtitle: "Tandem paragliding over the mountains of Rivas de Pérez Zeledón, Uvita, Dominical and the wild beaches of Dominicalito. Zero experience required.",
      cta_book: "Book Your Flight",
      cta_whatsapp: "WhatsApp Us",
    },
    trust: {
      insured: "Fully Insured",
      insured_desc: "Every passenger covered on every flight",
      certified: "Certified Pilots",
      certified_desc: "Licensed & over experienced pilots",
      dual: "Stunning Landscapes",
      dual_desc: "Most exclusive landscapes.",
    },
    destinations: {
      overline: "Iconic Launch Sites",
      title: "Limitless horizons. One unforgettable ride.",
      rivas_title: "Rivas de Pérez Zeledón",
      rivas_desc: "Fly from Alex's Launch, 1750m! Fly above the Valle El General, Pérez Zeledón. Panoramic mountain views and smooth thermals that carry you for miles.",
      dominical_title: "Playa Dominicalito - Dominical",
      dominical_desc: "Coastal paragliding above Costa Rica's Pacific. Dominical and Dominicalito View Soar over surfers and palm-fringed shorelines. ",
      uvita_title: "Dominicalito - Whale Tail",
      uvita_desc: "Paragliding flight along the coast towards Uvita and the Whale's Tail in Marino Ballena National Park, with a safe landing on Dominicalito Beach.",
      brazil_title: "Caraguatatuba, Brazil",
      brazil_desc: "Beach flights along Martim de Sá beach with rays and sea turtles spotted below. Departures from São Paulo's North Coast.",
      from: "From",
      per_person: "/ person",
    },
    packages: {
      overline: "Choose your sky",
      title: "Choose your adventure.",
      subtitle: "Prices in USD. A $20 online deposit secures your slot — pay the rest on landing.",
      book_now: "Book with $20 Deposit",
      pay_full: "Pay Full Amount",
      duration: "min in the air",
      includes: "Includes: safety briefing · insurance · GoPro photo option",
    },
    booking: {
      overline: "Reserve Your Slot",
      title: "Ready to fly?",
      subtitle: "Fill in your details. We confirm availability within 2 hours by WhatsApp or email.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      passengers: "Passengers",
      date: "Preferred date",
      package: "Choose tour",
      notes: "Notes (optional)",
      payment_type: "Payment",
      deposit: "Deposit ($20)",
      full: "Full price",
      submit: "Continue to Secure Checkout",
      submitting: "Redirecting to Stripe…",
      success: "Booking created — redirecting to payment.",
      error: "Something went wrong. Try again or WhatsApp us.",
    },
    gallery: {
      overline: "In the Air",
      title: "Real people. Real smiles. Real flights.",
    },
    testimonials: {
      overline: "Passenger Voices",
      title: "Five stars, one thousand goosebumps.",
    },
    faq: {
      overline: "Everything you want to ask",
      title: "Frequently asked questions.",
      q1: "Do I need experience?",
      a1: "None. In a tandem flight you simply enjoy the pura vida view while a certified pilot handles everything. We fly people from 5 to 85 years old.",
      q2: "Is there a weight limit?",
      a2: "Maximum passenger weight is 135 kg (297 lbs). BMI under 33 for safety.",
      q3: "How long is the flight?",
      a3: "Standard flights last 20–30 minutes. Long-distance or instructional flights can extend up to 45–60 minutes.",
      q4: "What if the weather is bad?",
      a4: "Safety first. If conditions are unsuitable we reschedule at no cost or refund your deposit.",
      q5: "Do you provide photos/video?",
      a5: "Yes — GoPro & Insta360 add-ons available on all flights. Drone footage on request. Birthday flyers get GoPro footage free.",
      q6: "Can I pay in cash or crypto?",
      a6: "Yes! Online deposit is via card (Stripe). The remainder can be paid in cash (USD/CRC), card, or Bitcoin at the launch site.",
    },
    footer: {
      tagline: "Tandem paragliding safe & fun.",
      contact: "Contact",
      locations: "Locations",
      lang: "Language",
      rights: "All rights reserved.",
      shop: "All tours",
destinations: "Destinations",
media: "Social Media",
book: "Book now",
photos: "Photo gallery"
    },
    success: {
      title: "Your flight is booked!",
      subtitle: "We're checking your payment status…",
      paid: "Payment confirmed. Check your inbox for confirmation and preparation tips.",
      pending: "Payment is being processed. This can take a moment.",
      expired: "Session expired. Please try booking again.",
      back: "Back to home",
    },
    cancel: {
      title: "Payment cancelled",
      subtitle: "No charge was made. You can pick up right where you left off.",
      back: "Return to booking",
    },
  },
  es: {
    "social": {
    "tagline": "Sigue el vuelo",
    "title": "Nuestras redes sociales",
    "description": "Vuelos en vivo, detrás de cámaras y los mejores paisajes de Rivas y Dominical — síguenos de cerca en cualquiera de nuestras redes.",
    "camera": "Galería",
    "h2": "Momentos en el aire",
    "paragraph": "Una selección de fotos de nuestros vuelos — la vista de Rivas, Dominical y la costa del Pacífico desde las alturas."
  },
     book:{
      deposit:"Asegura tu horario ",
      balance:"pagás el resto al aterrizar"
    },
    nav: {
      destinations: "Destinos",
      tours: "Tandem",
      gallery: "Galería",
      faq: "Preguntas",
      book: "Reservar",
      costarica: "Costa Rica",
      brasil: "Brasil",
      peru: "Peru",
      argentina: "Argentina",
      canada: "Canada",
      rd: "República Dominicana",
      rivas_perezzeledon: "Rivas de Pérez Zeledón, Costa Rica",
      dominicalito_dominical: "Dominicalito & Dominical, Costa Rica",
      uvita_whaletail: "Uvita · Whale Tail, Costa Rica",
      oasis_huacachina_peru: "Oasis Huacachina, Peru",
      florianopolis_brasil: "Florianópolis, Brazil",
      bariloche_argentina: "Bariloche, Argentina",
      ilha_do_mel: "Ilha do Mel, Brazil",
      caraguatatuba: "Caraguatatuba, Brazil",
    },
    hero: {
      image: "https://ik.imagekit.io/paraglidetour/the_best_paragliding_tour/parapente_perez_zeledon_pura_vida.webp",
      overline: "Costa Rica ·  Parapente Tándem · Pura Vida",
      title: "Vuela con los pájaros en Pérez Zeledón.",
      subtitle: "Parapente biplaza sobre las montañas de Rivas de Pérez Zeledón y las playas salvajes de Dominicalito, Dominical y Uvita. No ocupás experiencia.",
      cta_book: "Reservá tu vuelo",
      cta_whatsapp: "Escríbenos WhatsApp",
    },
    trust: {
      insured: "Asegurado",
      insured_desc: "Cada pasajero cubierto en cada vuelo",
      certified: "Pilotos Profesionales Certificados",
      certified_desc: "Licencia y amplia experiencia",
      dual: "Paisajes únicos",
      dual_desc: "Disfrute del maravilloso privilegio de volar en Costa Rica.",
    },
    destinations: {
      overline: "Sitios de despegue icónicos",
      title: "Cielos infinitos. Un vuelo inolvidable.",
      rivas_title: "Rivas de Pérez Zeledón",
      rivas_desc: "Despegue desde el Launch de Alex, 1750m! Vuele sobre el Valle El General. Vistas panorámicas y térmicas que te llevan lejos.",
      dominical_title: "Playa Dominicalito",
      dominical_desc: "Parapente costero sobre el Pacífico con vista a Dominicalito y Dominical. Volá sobre surfistas y playas orladas de palmeras.",
      uvita_title: "Dominicalito - Uvita · Cola de Ballena",
      uvita_desc: "Vuelo en parapente a lo largo de la costa mirando hacia Uvita y la Cola de la Ballena en el Parque Nacional Marino Ballena, con un aterrizaje seguro en la playa Dominicalito.",
      brazil_title: "Caraguatatuba, Brasil",
      brazil_desc: "Vuelos de playa en Praia Martim de Sá con rayas y tortugas debajo. Salidas del Litoral Norte de São Paulo.",
      from: "Desde",
      per_person: "/ persona",
    },
    packages: {
      overline: "Montaña y Playa",
      title: "Elegí tu aventura.",
      subtitle: "Precios en USD. Un depósito de $20 asegura tu horario — pagás el resto al aterrizar.",
      book_now: "Reservar con $20",
      pay_full: "Pagar total",
      duration: "min en el aire",
      includes: "Incluye: briefing · seguro · opción de foto GoPro",
    },
    booking: {
      overline: "Reservá tu espacio",
      title: "¿Listo para volar?",
      subtitle: "Completá tus datos. Confirmamos disponibilidad en menos de 2 horas por WhatsApp o email.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      passengers: "Pasajeros",
      date: "Fecha preferida",
      package: "Elegí tu vuelo",
      notes: "Notas (opcional)",
      payment_type: "Pago",
      deposit: "Depósito ($20)",
      full: "Precio total",
      submit: "Continuar al pago seguro",
      submitting: "Redirigiendo a Stripe…",
      success: "¡Reserva creada — redirigiendo al pago!",
      error: "Algo salió mal. Intentá de nuevo o escribinos WhatsApp.",
    },
    gallery: {
      overline: "En el aire",
      title: "Vuelos reales. Sonrisas reales.",
    },
    testimonials: {
      overline: "Voces de pasajeros",
      title: "Cinco estrellas, mil escalofríos.",
    },
    faq: {
      overline: "Todo lo que querés preguntar",
      title: "Preguntas frecuentes.",
      q1: "¿Ocupo experiencia?",
      a1: "Ninguna. En un vuelo biplaza solo disfrutás la vista mientras el piloto certificado maneja todo. Volamos personas de 5 a 85 años.",
      q2: "¿Hay límite de peso?",
      a2: "El máximo es 135 kg (297 lbs). El IMC debe ser menor a 33 por seguridad.",
      q3: "¿Cuánto dura el vuelo?",
      a3: "Vuelos estándar duran 20–30 minutos. Vuelo instruccional y vuelos largos hasta 45–60 minutos.",
      q4: "¿Y si el clima está feo?",
      a4: "Seguridad primero. Si el clima no colabora, reprogramamos sin costo o te devolvemos el depósito.",
      q5: "¿Incluye fotos/video?",
      a5: "Sí — GoPro e Insta360 disponibles en todos los vuelos. Filmación con dron a pedido. Cumpleañeros ganan GoPro de cortesía.",
      q6: "¿Puedo pagar en efectivo o cripto?",
      a6: "Si! El depósito online es con tarjeta (Stripe). El resto podés pagarlo en efectivo (USD/CRC), tarjeta o Bitcoin en el sitio.",
    },
    footer: {
      tagline: "Parapente Tándem Pura Vida.",
      contact: "Contacto",
      locations: "Ubicaciones",
      lang: "Idioma",
      rights: "Todos los derechos reservados.",
      shop: "Todos los tours",
destinations: "Destinos",
media: "Redes Sociales",
book: "Reserva ya",
photos: "Galería de fotos",
    },
    success: {
      title: "¡Tu vuelo está reservado!",
      subtitle: "Estamos verificando tu pago…",
      paid: "Pago confirmado. Revisá tu correo para confirmación y tips de preparación.",
      pending: "Procesando el pago. Puede tardar un momento.",
      expired: "La sesión expiró. Intentá reservar otra vez.",
      back: "Volver al inicio",
    },
    cancel: {
      title: "Pago cancelado",
      subtitle: "No se realizó ningún cargo. Podés continuar donde lo dejaste.",
      back: "Volver a la reserva",
    },
  },
  pt: {
     "social": {
    "tagline": "Siga o voo",
    "title": "Nossas redes sociais",
    "description": "Voos ao vivo, bastidores e as melhores paisagens de Rivas e Dominical — acompanhe de perto em qualquer uma das nossas redes.",
    "camera": "Galeria",
    "h2": "Momentos no ar",
    "paragraph": "Uma seleção de fotos dos nossos voos — a vista de Rivas, Dominical e da costa do Pacífico vistas do alto."
  },
    book:{
      deposit:"Valor da Reserva",
      balance:"O restante após voar"
    },
    nav: {
      destinations: "Destinos",
      tours: "Voo Duplo",
      gallery: "Galeria",
      faq: "Perguntas",
      book: "Reservar",
      costarica: "Costa Rica",
      brasil: "Brasil",
      peru: "Peru",
      argentina: "Argentina",
      canada: "Canada",
      rd: "República Dominicana",
      florianopolis_brasil: "Florianópolis, Brasil",
      bariloche_argentina: "Bariloche, Argentina",
      ilha_do_mel: "Ilha do Mel, Brasil",
      caraguatatuba: "Caraguatatuba, Brasil",
      rivas_perezzeledon: "Rivas de Pérez Zeledón, Costa Rica",
      dominicalito_dominical: "Dominicalito & Dominical, Costa Rica",
      uvita_whaletail: "Uvita · Whale Tail, Costa Rica",
      oasis_huacachina_peru: "Oasis Huacachina, Peru",
    },
    hero: {
      image:"https://ik.imagekit.io/paraglidetour/the_best_paragliding_tour/parapente_litoral_caraguatatuba_martim_de_sa.webp",
      overline: "Voo Duplo · Na Praia ",
      title: "Voe na pria Martim de Sá com vista para Ilhabela.",
      subtitle: "Voo de parapente na Praia Martim de Sá em Caraguatatuba , Litoral Norte SP. Sem experiência necessária.",
      cta_book: "Agende seu voo",
      cta_whatsapp: "Fale no WhatsApp",
    },
    trust: {
      insured: "Voo com seguro",
      insured_desc: "Todos os passageiros cobertos em cada voo",
      certified: "Pilotos Profissionais Certificados",
      certified_desc: "Licenciados co experiência comprovada",
      dual: "Paisagens espetaculares",
      dual_desc: "Descubra o privilégio que é voar",
    },
    destinations: {
      overline: "Rampas icônicas",
      title: "Diversos céus. Um voo inesquecível.",
      rivas_title: "Rivas de Pérez Zeledón",
      rivas_desc: "Rampa do Alex, 1750m! Voe acima do Valle El General. Vistas panorâmicas e térmicas que te levam longe.",
      dominical_title: "Playa Dominicalito",
      dominical_desc: "Parapente costeiro sobre o Pacífico da Costa Rica em Dominicalito e dominical. Voe sobre surfistas e praias de coqueiros.",
      uvita_title: "Dominicalito - Uvita",
      uvita_desc: "Voo de parapente ao longo da costa em direção a Uvita e à Cauda da Baleia (Whale's Tail), no Parque Nacional Marino Ballena, com pouso seguro na Praia de Dominicalito.",
      brazil_title: "Praia Martim de Sá, São Paulo, Brasil",
      brazil_desc: "Voos hike and fly na Praia Martim de Sá com arraias e tartarugas marinhas embaixo. Saídas do Litoral Norte de SP.",
      from: "A partir de",
      per_person: "/ pessoa",
    },
    packages: {
      overline: "Cardápio de voos",
      title: "Escolha sua aventura.",
      subtitle: "Preços em USD. Depósito online de $20 garante seu horário — pague o resto ao pousar.",
      book_now: "Reservar com $20",
      pay_full: "Pagar total",
      duration: "min no ar",
      includes: "Inclui: briefing · seguro · opção foto GoPro",
    },
    booking: {
      overline: "Garanta seu horário",
      title: "Pronto para voar?",
      subtitle: "Preencha seus dados. Confirmamos disponibilidade em até 2h por WhatsApp ou email.",
      name: "Nome completo",
      email: "E-mail",
      phone: "Telefone / WhatsApp",
      passengers: "Passageiros",
      date: "Data preferida",
      package: "Escolha o voo",
      notes: "Observações (opcional)",
      payment_type: "Pagamento",
      deposit: "Depósito ($20)",
      full: "Preço total",
      submit: "Continuar para pagamento seguro",
      submitting: "Redirecionando para Stripe…",
      success: "Reserva criada — redirecionando ao pagamento!",
      error: "Algo deu errado. Tente novamente ou chame no WhatsApp.",
    },
    gallery: {
      overline: "No ar",
      title: "Voos reais. Sorrisos reais.",
    },
    testimonials: {
      overline: "Vozes dos passageiros",
      title: "Cinco estrelas, mil arrepios.",
    },
    faq: {
      overline: "Tudo que você quer saber",
      title: "Perguntas frequentes.",
      q1: "Preciso ter experiência?",
      a1: "Nenhuma. Em um voo duplo você só aproveita a vista enquanto o piloto certificado cuida de tudo. Voamos com pessoas de 5 a 85 anos.",
      q2: "Tem limite de peso?",
      a2: "Máximo de 135 kg (297 lbs). IMC abaixo de 33 por segurança.",
      q3: "Quanto tempo dura o voo?",
      a3: "Voos padrão duram 20–30 minutos. Voos instrucionais e voos longos podem ir até 45–60 minutos.",
      q4: "E se o tempo não colaborar?",
      a4: "Segurança primeiro. Se as condições não permitirem, remarcamos sem custo ou devolvemos o depósito.",
      q5: "Vocês fornecem foto/vídeo?",
      a5: "Sim — GoPro e Insta360 disponíveis em todos os voos. Drone sob demanda. Aniversariantes ganham GoPro de cortesia.",
      q6: "Posso pagar em dinheiro ou cripto?",
      a6: "Sim! O depósito online é por cartão (Stripe). O restante pode ser em dinheiro (USD/CRC/BRL), cartão ou Bitcoin no local.",
    },
    footer: {
      tagline: "Voo duplo com segurança e diversão.",
      contact: "Contato",
      locations: "Localidades",
      lang: "Idioma",
      rights: "Todos os direitos reservados.",
      shop:"Todos os passeios",
      destinations:"Destinos",
      media:"Redes Sociais",
      book:"Reserve já",
      photos:"Galeria de fotos"
      

    },
    success: {
      title: "Seu voo está reservado!",
      subtitle: "Estamos verificando o pagamento…",
      paid: "Pagamento confirmado. Confira seu email para confirmação e dicas de preparação.",
      pending: "Processando pagamento. Pode levar um momento.",
      expired: "Sessão expirou. Tente reservar novamente.",
      back: "Voltar ao início",
    },
    cancel: {
      title: "Pagamento cancelado",
      subtitle: "Nenhuma cobrança feita. Você pode continuar de onde parou.",
      back: "Voltar à reserva",
    },
  },
};
